type SuccessResult = {
  type: 'SUCCESS';
};

type ErrorResult = {
  type: 'ERROR';
  data: {
    error: { message: string; code: number };
  };
};

export type AddSitePluginModalResult = SuccessResult | ErrorResult;

export class AddSitePluginModalError extends Error {
  code: number;
  constructor({ message, code }: { message: string; code: number }) {
    super(message);
    this.message = message;
    this.code = code;
  }
}

export type AddSitePlugin = (
  pluginId: string,
  options?: {
    placement?: {
      appDefinitionId: string;
      widgetId: string;
      slotId: string;
    };
    slotId?: string;
  },
) => Promise<void>;
